import SearchIcon from "@mui/icons-material/Search";
import {
	Grid2,
	IconButton,
	InputAdornment,
	Paper,
	TextField,
} from "@mui/material";
import React from "react";
import {
	SearchShiftsParameters,
	ShiftPeriodNavigatorControl,
} from "../../../../../controls";
import {
	type Section,
	SectionMultiSelect,
} from "../../../../../controls/section-selector";

const customPeriodOptions = [
	{ value: "Day", label: "Day" },
	{ value: "4Days", label: "4 Days" },
	{ value: "Week", label: "Week" },
	{ value: "Month", label: "Month" },
	{ value: "Custom", label: "Custom" },
];

type Props = {
	quickFilter: string;
	onQuickFilterChange: (text: string) => void;
	shiftPeriod: SearchShiftsParameters;
	onChangeShiftPeriod: (
		value: SearchShiftsParameters,
		period: string | null,
	) => void;
	actualPeriod?: string | null;
	// Section filter
	selectedSections: Section[];
	onSectionsChange: (sections: Section[]) => void;
};

export const Filters = ({
	quickFilter,
	onQuickFilterChange,
	shiftPeriod,
	onChangeShiftPeriod,
	actualPeriod,
	selectedSections,
	onSectionsChange,
}: Props) => {
	const handleShiftPeriodChange = (
		value: SearchShiftsParameters,
		period: string | null,
	) => {
		onChangeShiftPeriod(value, period);
	};

	return (
		<Paper elevation={1} style={{ padding: 8 }}>
			<Grid2 container spacing={1}>
				<Grid2 size={{ xs: 12 }} alignItems="center" justifyContent="center">
					<ShiftPeriodNavigatorControl
						onChange={handleShiftPeriodChange}
						value={shiftPeriod}
						actualPeriod={actualPeriod}
						showShiftAndCrews={false}
						dateFormat="MM/DD/YYYY"
						periodOptions={customPeriodOptions}
					/>
				</Grid2>

				{/* Search + Section filter in same row */}
				<Grid2 size={{ xs: 12, md: 3 }}>
					<TextField
						fullWidth
						label="Search"
						variant="outlined"
						size="small"
						value={quickFilter}
						onChange={(event) => {
							onQuickFilterChange(event?.target.value);
						}}
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<IconButton edge="start" type="submit">
										<SearchIcon />
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
				</Grid2>
				<Grid2 size={{ xs: 12, md: 9 }}>
					<SectionMultiSelect
						value={selectedSections}
						onChange={onSectionsChange}
						label="Sections"
					/>
				</Grid2>
			</Grid2>
		</Paper>
	);
};
